type ListViewSortParam =
  | ''
  | 'name'
  | 'address'
  | 'created'
  | 'modified'
  | 'channel'
  | 'stage';

type ListViewSortDirection = 'ASC' | 'DESC';

const LIST_VIEW_SORT_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: 'Sort By' },
  { value: 'name-ASC', label: 'Name (A-Z)' },
  { value: 'name-DESC', label: 'Name (Z-A)' },
  { value: 'address-ASC', label: 'Address (A-Z)' },
  { value: 'address-DESC', label: 'Address (Z-A)' },
  { value: 'created-DESC', label: 'Created (Newest)' },
  { value: 'created-ASC', label: 'Created (Oldest)' },
  { value: 'modified-DESC', label: 'Modified (Newest)' },
  { value: 'modified-ASC', label: 'Modified (Oldest)' },
  { value: 'channel-ASC', label: 'Channel (A-Z)' },
  { value: 'channel-DESC', label: 'Channel (Z-A)' },
  { value: 'stage-ASC', label: 'Stage (A-Z)' },
  { value: 'stage-DESC', label: 'Stage (Z-A)' },
];

const COLUMN_LABEL_TO_PARAM: Record<string, ListViewSortParam> = {
  Name: 'name',
  Address: 'address',
  Created: 'created',
  Modified: 'modified',
  Channel: 'channel',
  Stage: 'stage',
};

const PARAM_TO_COLUMN_LABEL: Record<ListViewSortParam, string> = {
  '': '',
  name: 'Name',
  address: 'Address',
  created: 'Created',
  modified: 'Modified',
  channel: 'Channel',
  stage: 'Stage',
};

function parseSortValue(value: string): {
  param: ListViewSortParam;
  direction: ListViewSortDirection;
} {
  if (!value) return { param: '', direction: 'DESC' };
  const [param, dir] = value.split('-');
  return {
    param: (param || '') as ListViewSortParam,
    direction: dir === 'ASC' ? 'ASC' : 'DESC',
  };
}

function toSortValue(
  param: ListViewSortParam,
  direction: ListViewSortDirection,
): string {
  if (!param) return '';
  return `${param}-${direction}`;
}

export {
  type ListViewSortParam,
  type ListViewSortDirection,
  LIST_VIEW_SORT_OPTIONS,
  COLUMN_LABEL_TO_PARAM,
  PARAM_TO_COLUMN_LABEL,
  parseSortValue,
  toSortValue,
};
